// extracted by mini-css-extract-plugin
export default {"back":"TM539","alternative":"oe9S8","alternative--selected":"TWerz"};